// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import AddressSchema from './address-schema';

const schema = {
  $id: '/address-validation-schema',
  type: 'object',
  required: [],
  properties: {
    addresses: {
      type: 'array',
      nullable: true,
      items: { ...AddressSchema },
    },
    isCountrySupported: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
